import { render, staticRenderFns } from "./matrixscale.vue?vue&type=template&id=7f9b8679&scoped=true&"
import script from "./matrixscale.vue?vue&type=script&lang=js&"
export * from "./matrixscale.vue?vue&type=script&lang=js&"
import style0 from "./matrixscale.vue?vue&type=style&index=0&id=7f9b8679&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9b8679",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f9b8679')) {
      api.createRecord('7f9b8679', component.options)
    } else {
      api.reload('7f9b8679', component.options)
    }
    module.hot.accept("./matrixscale.vue?vue&type=template&id=7f9b8679&scoped=true&", function () {
      api.rerender('7f9b8679', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/ItemConfig/matrixscale.vue"
export default component.exports